import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { AxiosContext } from "../services/axios/AxiosContext";
import { ResponseCompanyActiveRoutes } from "@mysnowscape/snow-lib";

export default function useQueryActiveRoutes(
  companyId: string,
  includePaused = false,
) {
  const axios = useContext(AxiosContext);
  const activeRoutesQuery = useQuery({
    queryKey: ["company", companyId, "activeRoutes-new", includePaused],
    queryFn: async () => {
      const result: ResponseCompanyActiveRoutes = (
        await axios.get(
          `activeRoute/company-new/${companyId}?include=staff${includePaused ? ",paused" : ""}&take=10000`,
        )
      ).data;
      return result;
    },
  });

  return activeRoutesQuery;
}
